"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScheduleRowEndBalanceFormula = void 0;
exports.getScheduleRowEndBalance = getScheduleRowEndBalance;
const general_formulas_1 = require("./general-formulas");
/*
 * Enumeration of ScheduleRowPaymentAmount formala implementation names
 */
var ScheduleRowEndBalanceFormula;
(function (ScheduleRowEndBalanceFormula) {
    ScheduleRowEndBalanceFormula[ScheduleRowEndBalanceFormula["DEFAULT"] = 0] = "DEFAULT";
})(ScheduleRowEndBalanceFormula || (exports.ScheduleRowEndBalanceFormula = ScheduleRowEndBalanceFormula = {}));
/**
 * Returns the specified draw fee formula implementation
 */
function getScheduleRowEndBalance(formula) {
    switch (formula) {
        default:
            return default_scheduleRowEndBalance;
    }
}
///////////////////////////
// Function Implementations
///////////////////////////
const default_scheduleRowEndBalance = (params) => {
    // ensure valid argument types
    if (typeof params.startBalance === 'number' && typeof params.currentRow === 'object'
        && typeof params.paymentIndex === 'number' && typeof params.previousRow === 'object') {
        if (typeof params.currentRow.principalAmount === 'number') {
            const outstandingBalance = params.paymentIndex == 0 ? params.startBalance : params.previousRow.endBalance;
            return (0, general_formulas_1.toFixedNumber)(outstandingBalance - params.currentRow.principalAmount, 2);
        }
    }
    return NaN;
};
//# sourceMappingURL=schedule-row-end-balance-formula.js.map